export const BLOCK_INTERFACE = 'BLOCK_INTERFACE';
export const RELEASE_INTERFACE = 'RELEASE_INTERFACE';

export const ENABLE_GOOGLE_API = 'ENABLE_GOOGLE_API';
export const DISABLE_GOOGLE_API = 'DISABLE_GOOGLE_API';

export const DEFINE_USER = 'DEFINE_USER';
export const CLEAR_USER = 'CLEAR_USER';
export const DEFINE_USER_PICTURE_PROFILE = 'DEFINE_USER_PICTURE_PROFILE';

export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';

export const RECOVER_DATA = 'RECOVER_DATA';

export const RESTART_SESSION = 'RESTART_SESSION';
export const ALERT_SESSION_ENDING = 'ALERT_SESSION_ENDING';
export const DEFINE_SESSION_TIMEOUT = 'DEFINE_SESSION_TIMEOUT';
export const CLEAR_SESSION_TIMEOUT = 'CLEAR_SESSION_TIMEOUT';

export const DEFINE_UNAUTH_REDIRECT = 'DEFINE_UNAUTH_REDIRECT';
export const CLEAR_UNAUTH_REDIRECT = 'CLEAR_UNAUTH_REDIRECT';

export const DEFINE_CAMPAIGN_URL = 'DEFINE_CAMPAIGN_URL';



// WEBPACK FOOTER //
// ./src/vuex/types/actions.js